import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=4b582c52&scoped=true&"
import script from "./Forum.vue?vue&type=script&lang=js&"
export * from "./Forum.vue?vue&type=script&lang=js&"
import style0 from "./Forum.vue?vue&type=style&index=0&id=4b582c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b582c52",
  null
  
)

export default component.exports